export const GiftBoxBottomIcon = () => {
  return (
    <svg
      className="box-bottom"
      width="16"
      height="11"
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="14" height="10" rx="0.5" stroke="currentColor" />
      <path d="M0 7.33972H14.3158" stroke="currentColor" />
      <path d="M12.0789 5.18427L9.39471 1.15796" stroke="currentColor" strokeLinecap="round" />
      <path d="M2.23682 5.18427L4.92103 1.15796" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
};
